<template>
    <div class="card card-body mt-4">
        <router-link :to="`/feedtype/add/`">
            <button class="btn btn-primary btn-sm me-2">
                Add New Feed Type
            </button>
        </router-link>
    </div>
</template>

